import React from 'react'
import Receipt from '../components/CustomerDisplay/Receipt'
import Ticket from '../components/CustomerDisplay/Ticket'
import TitleBar from '../components/CustomerDisplay/TitleBar'
import PaymentModal from '../components/CustomerDisplay/PaymentModal'
import { connect } from 'react-redux'
import { getObjectItem } from '../actions/dataActions'
import * as types from '../constants/Types'
import $ from 'jquery'

class CustomerDisplayPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { lines: [], title: '', subtotal: 0, customerMessage: '', ticketValidation: null };

        this.stateChanged = this.stateChanged.bind(this);
        this.getReceiptTitle = this.getReceiptTitle.bind(this);
        this.getReceiptAmount = this.getReceiptAmount.bind(this);
        this.getCustomerMessage = this.getCustomerMessage.bind(this);
        this.getTicketValidation = this.getTicketValidation.bind(this);
    }

    componentDidMount() {
        window.addEventListener('storage', this.stateChanged, true);
    }

    componentDidUpdate() {
        // this scrolls the receipt lines to the bottom
        // it is a nasty, very un-react-like hack
        // but this is the way it is also done in the article button, so we will use this for now
        setTimeout(function scrollToBottom() {
            $('.receipt-body-customer').scrollTop(9999);
        }, 50);
    }

    stateChanged(event) {
        if (event.key === 'store') {
            const state = JSON.parse(event.newValue);

            const receiptState = state.receiptState.receipt;
            const ticketState = state.ticket;
            const title = this.getReceiptTitle(receiptState);
            const subtotal = this.getReceiptAmount(receiptState);
            const customerMessage = this.getCustomerMessage(receiptState);
            const ticketValidation = this.getTicketValidation(ticketState);

            this.setState({ lines: receiptState.lines, title: title, subtotal: subtotal, customerMessage: customerMessage, ticketValidation: ticketValidation });
        }
    }

    getReceiptAmount(receiptState) {
        let receiptAmount = 0;
        receiptState.lines.map(line => {
            if (line.linetype !== types.SUBTOTAL_LINE) {
                line.discount.map(discount => {
                    receiptAmount += (discount.Price.toFixed(2)) / 1;
                    return '';
                })
                receiptAmount += (line.price.toFixed(2)) / 1;
            }
            return '';
        });

        return receiptAmount;
    }

    getReceiptTitle(receiptState) {
        const titleItems = [];
        if (receiptState.receiptnumber) {
            titleItems.push(`#${receiptState.receiptnumber}`);
        }
        if (receiptState.objectitemid) {
            const objectItem = this.props.getObjectItem(receiptState.objectitemid);
            if (objectItem !== null) {
                titleItems.push(`${objectItem.ItemNumber}`);
            }
        }

        if (receiptState.objectitemname && receiptState.objectitemname !== '') {
            titleItems.push(`${receiptState.objectitemname}`);
        }
        else if (receiptState.objectitemdescription) {
            titleItems.push(`${receiptState.objectitemdescription}`);
        }

        let title = '';
        titleItems.map(item => {
            if (title !== '') {
                title = `${title} - `;
            }
            title = `${title}${item}`;
            return '';
        })

        return title;
    }

    getCustomerMessage(receiptState) {
        let customerMessage = '';
        if (receiptState.customer && receiptState.customer.customerid > 0) {
            customerMessage = `${receiptState.customer.customerName} - Saldo: ${receiptState.customer.customerSaldo.toFixed(2).replace('.', ',')}`;
        }

        return customerMessage;
    }

    getTicketValidation(ticketState) {
       return ticketState.validationResult;
    }

    render() {
        return (
            <div>
                <div id="app" className="customerdisplay">
                    <div id="main-container">
                        <TitleBar />
                        <Ticket ticketValidation={this.state.ticketValidation}/>
                        <Receipt lines={this.state.lines} title={this.state.title} subtotal={this.state.subtotal} customerMessage={this.state.customerMessage}/>
                        <PaymentModal />
                    </div>
                </div>
        
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

export default connect(mapStateToProps, { getObjectItem })(CustomerDisplayPage)



// WEBPACK FOOTER //
// src/pages/CustomerDisplayPage.jsx